import { Routes }                 from '@angular/router';

import {LoginComponent, LoginLayoutComponent} from './login';

import { MainLayoutComponent }    from './shared';

import { PageNotFoundComponent }  from './routing';
import { AuthGuard }              from './services';
import { DashboardComponent }     from './dashboard/dashboard.component';
import { ClientsComponent }       from './clients/clients.component';
import { OrdersComponent }        from './orders/orders.component';
import {OrderDetailComponent} from './orders/detail/order-detail.component';
import {AccountsComponent} from './accounts/accounts.component';
import {AccountDetailComponent} from './accounts/detail/account-detail.component';
import {AdministratorGuard} from './services/administrator-guard';
import {ClientDetailComponent} from './clients/components/client-detail.component';
import {UsersComponent} from './accounts/detail/components/users/users.component';
import {LocationsComponent} from "./accounts/detail/components/locations/locations.component";
import {ShopComponent} from './shop/shop.component';
import {DistributorGuard} from './services/distributor-guard';
import {DistributorAccountsComponent} from './distributor/distributor-accounts.component';
import {WaiversComponent} from './accounts/detail/components/waivers/waivers.component';
import {AppointmentComponent} from './appointments/appointment.component';
import {PublicationsComponent} from './accounts/detail/components/publication/publications.component';
import {ExportsComponent} from './accounts/detail/components/export/exports.component';
import {TelehealthComponent} from './telehealth/telehealth.component';
import {DeferredSessionComponent} from './live/deferred-session.component';
import {LiveSessionComponent} from './live/live-session.component';
import {ProfileComponent} from './profile/profile.component';
import {ImportComponent} from './accounts/detail/components/import/import.component';
import {RegisterComponent} from './register/register.component';
import {CommissionsComponent} from './commissions/commissions.component';
import {ConnectResultComponent} from './profile/connect-result.component';
import {CurateComponent} from './curate/curate.component';
import {ManagerGuard} from './services/manager-guard/manager-guard.service';
import {ManagingDistributorGuard} from './services/distributor-guard/managing-distributor-guard.service';

export const routes: Routes = [
  {
    path: 'auth', component: LoginLayoutComponent,
    children: [
      {path: '', redirectTo: 'login', pathMatch: 'full'},
      {
        path: 'login', component: LoginComponent,
        data: {pageTitle: 'Login', className: 'login-page'}
      }
    ]
  },
  {
    path: 'sessions/:id/live', component: LiveSessionComponent, canActivate: [AuthGuard]
  },
  {
    path: 'register/:account/:location', component: RegisterComponent
  },
  {
    path: 'sessions/:id/deferred',
    component: DeferredSessionComponent, canActivate: [AuthGuard]
  },
  {
    path: '', component: MainLayoutComponent, canActivate: [AuthGuard],
    children: [
      {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard]
        /*loadChildren: './dashboard/dashboard.module#DashboardModule'*/
      },
      {
        path: 'telehealth',
        component: TelehealthComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'commissions',
        component: CommissionsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'accounts/:id/curate',
        component: CurateComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'clients',
        component: ClientsComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'clients/:id',
        component: ClientDetailComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'connect/failure',
        component: ConnectResultComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'connect/success',
        component: ConnectResultComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'orders',
        component: OrdersComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'orders/:id',
        component: OrderDetailComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'accounts',
        canActivate: [AdministratorGuard, AuthGuard],
        component: AccountsComponent,
      },
      {
        path: 'appointments',
        canActivate: [ManagerGuard, AuthGuard],
        component: AppointmentComponent,
      },
      {
        path: 'accounts/:id',
        component: AccountDetailComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'accounts/:id/shop',
        component: ShopComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'accounts/:id/users',
        component: UsersComponent,
        canActivate: [ManagerGuard, AuthGuard]
      },
      {
        path: 'accounts/:id/locations',
        component: LocationsComponent,
        canActivate: [ManagerGuard, AuthGuard]
      },
      {
        path: 'accounts/:id/publication',
        component: PublicationsComponent,
        canActivate: [ManagerGuard, AuthGuard]
      },
      {
        path: 'accounts/:id/waivers',
        component: WaiversComponent,
        canActivate: [ManagerGuard, AuthGuard]
      },
      {
        path: 'accounts/:id/export',
        component: ExportsComponent,
        canActivate: [ManagerGuard, AuthGuard]
      },
      {
        path: 'accounts/:id/import',
        component: ImportComponent,
        canActivate: [ManagerGuard, AuthGuard]
      },
    ]
  },
  {
    path: 'distributor', component: MainLayoutComponent, canActivate: [DistributorGuard],
    children: [
      {path: '', redirectTo: 'dashboard', pathMatch: 'full'},
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [DistributorGuard]
      },
      {
        path: 'accounts',
        component: AccountsComponent,
        canActivate: [DistributorGuard, ManagerGuard]
      },
      {
        path: 'commissions',
        component: CommissionsComponent,
        canActivate: [DistributorGuard]
      },
      {
        path: 'profile',
        component: ProfileComponent,
        canActivate: [DistributorGuard]
      },
    ]
  },
  { path: '**', component: PageNotFoundComponent }
];
